import React from 'react'
import { Link } from "react-router-dom";
import { images } from '../../constants';

function CardRegister() {
  return (
    <div className='flex justify-center items-center'>
        <div style={{ maxHeight: '600px' }}  className="w-full max-w-md flex justify-center items-center  p-6  bg-white border border-gray-200 rounded-3xl shadow-2xl shadow-slate-300">
            <div className="flex items-center justify-center flex-col">
                <img
                    src={images.success}
                    alt="success"
                    style={{ width: "50px" }}
                />
                <p className='font-lato text-[20px]'>
                    Your account was successfully registered!
                </p>
                <button
                  className="bg-[#2D3494] hover:bg-white text-white font-lato hover:text-[#2D3494] hover:border border-[#2D3494] py-2 px-[3.2cm] mt-3 rounded-xl "
                >
                  <Link to="/login" className="flex justify-center font-bold">
                    Go To Login Page
                  </Link>
                </button>
                <p className='font-lato  text-[14px] mt-3'>
                 or 
                </p>
                <button
                  className="bg-transparent py-2 px-[3.2cm] mt-3 text-[#2D3494] hover:text-white border border-[#2D3494] hover:bg-[#2D3494] font-lato rounded-xl"
                >
                  <Link to="/" className="flex justify-center font-bold">
                    Back to Homepage
                  </Link>
                </button>
            </div>
        </div>
    </div>
  )
}

export default CardRegister